import { QuerifyService } from '@core/services/querify.service';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries";
import * as i3 from "./mutations";
import * as i4 from "../../services/querify.service";
var ApprovalsEquipmentsApi = /** @class */ (function () {
    function ApprovalsEquipmentsApi(apollo, queries, mutations, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.mutations = mutations;
        this.querify = querify;
    }
    ApprovalsEquipmentsApi.prototype.searchApprovalsEquipments = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getApprovalsEquipments(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['approvals'];
        }));
    };
    ApprovalsEquipmentsApi.prototype.searchOne = function (id) {
        return this.apollo
            .query({
            query: this.queries.getApprovalEquipment(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['approval'];
        }));
    };
    ApprovalsEquipmentsApi.prototype.acceptEquipment = function (id, message) {
        return this.apollo
            .query({
            query: this.mutations.acceptEquipment(),
            variables: { id: id, reason: message }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['acceptEquipment'];
        }));
    };
    ApprovalsEquipmentsApi.prototype.refuseEquipment = function (id, message) {
        return this.apollo
            .query({
            query: this.mutations.refuseEquipment(),
            variables: { id: id, reason: message }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['refuseEquipment'];
        }));
    };
    ApprovalsEquipmentsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApprovalsEquipmentsApi_Factory() { return new ApprovalsEquipmentsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.Mutations), i0.ɵɵinject(i4.QuerifyService)); }, token: ApprovalsEquipmentsApi, providedIn: "root" });
    return ApprovalsEquipmentsApi;
}());
export { ApprovalsEquipmentsApi };
